// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import type { PasswordPolicyRule } from '../../../types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from 'styled-theming';

const invalidColor = theme('mode', {
  light: '#b72f3c',
  dark: '#b72f3c'
});

const validColor = theme('mode', {
  light: '#265826',
  dark: '#265826'
});

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const StyledIcon = styled(FontAwesomeIcon)`
  color: ${invalidColor};
  margin-right: 0.5rem;

  ${props =>
    props.valid === 'true' &&
    css`
      color: ${validColor};
    `}
`;

type Props = { value: string, rules: Array<PasswordPolicyRule> };

const PolicyRuleList = React.memo<Props>((props: Props) => {
  const renderListItem = (
    item: PasswordPolicyRule,
    valid: boolean,
    index: number
  ): React.Node => (
    <li key={index}>
      <StyledIcon
        icon={['far', valid ? 'check-square' : 'square']}
        size="lg"
        valid={valid ? 'true' : 'false'}
      />
      <span>{item.text}</span>
    </li>
  );

  return (
    <List>
      {props.rules.map((rule, index) =>
        renderListItem(rule, rule.validate(props.value), index)
      )}
    </List>
  );
});

export default PolicyRuleList;
